export const config = {
  title: "Lavish Homes LLC | Milwaukee, WI",
  meta: {
    description:
      "Lavish Homes LLC offers professional remodeling and home improvement services in Milwaukee. From kitchens and bathrooms to full renovations, we bring your dream home to life.",
    keywords: [
      "Lavish Homes LLC",
      "Home Remodeling Milwaukee",
      "Kitchen Remodeling Milwaukee",
      "Bathroom Renovation",
      "Milwaukee Home Improvement",
      "Lavish Homes"
    ],
    author: "Lavish Homes LLC",
    canonicalUrl: "https://lavishhomesllc.org/",
  },
  sections: {
    header: {
      businessName: "Lavish Homes LLC",
    },
    sectionB: {
      heroTitle: "Transform Your Home with Lavish Homes",
      heroSubtitle: "Professional Remodeling & Home Improvement in Milwaukee",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "9453043176",
      phoneLabel: "(945) 304-3176",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1201121718/photo/open-plan-extension.jpg?s=612x612&w=0&k=20&c=DxaG5TG53qme2FNIIEBfkWxFSczGmmjR4-hJz3fggus=",
      cardData: [
        {
          title: "Kitchen Remodeling",
          description:
            "Upgrade your kitchen with modern designs, quality craftsmanship, and functional layouts.",
        },
        {
          title: "Bathroom Renovations",
          description:
            "Enhance comfort and style with our professional bathroom remodeling services.",
        },
        {
          title: "Full Home Renovations",
          description:
            "From flooring to complete renovations, we turn your vision into reality.",
        },
      ],
      description:
        "Lavish Homes LLC is a trusted remodeling company in Milwaukee, specializing in kitchens, bathrooms, and full home improvements.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We provide tailored home improvement solutions to fit your lifestyle, budget, and design preferences.",
      cards: [
        {
          title: "Kitchen Remodeling",
          description:
            "Modern designs and expert installations to create the kitchen of your dreams.",
          imageSrc: "https://media.istockphoto.com/id/1466145748/photo/kitchen-fitters-installing-some-cabinets.jpg?s=612x612&w=0&k=20&c=AtAGBHY6KWbf-HjoPrhGDNybh4-zqDF2OebNezuO3do=",
          imageAlt: "Kitchen Remodeling",
        },
        {
          title: "Bathroom Renovation",
          description:
            "Transform your bathroom with stylish upgrades and efficient layouts.",
          imageSrc: "https://media.istockphoto.com/id/2235725948/photo/the-bathroom-renovation-is-in-progress-focusing-on-plumbing-and-fixtures-under-construction.jpg?s=612x612&w=0&k=20&c=b8x05yFyMPR466sxnI35xNRNF_oJfJCg_m3QQuoA2GU=",
          imageAlt: "Bathroom Renovation",
        },
        {
          title: "Home Renovation",
          description:
            "Complete renovation services for living rooms, basements, and entire homes.",
          imageSrc: "https://media.istockphoto.com/id/2159965582/photo/private-residential-home-interiors-and-exteriors.jpg?s=612x612&w=0&k=20&c=XfMznCseA-C45T9qXOYQjwgYFJiP_hplOrKsMpQmYlA=",
          imageAlt: "Home Renovation",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Flooring Installation",
        "Interior Painting",
        "Basement Finishing",
        "Custom Carpentry",
        "Exterior Upgrades",
      ],
    },
    sectionD: {
      aboutTitle: "About Lavish Homes LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/166204053/photo/an-on-going-office-renovation.jpg?s=612x612&w=0&k=20&c=4wYJ3vhfQhItJnp5b1dSEA_HrEbRlsgWWOZ3X9LAwTY=",
        alt: "Lavish Homes Remodeling Team",
      },
      aboutText: [
        "Lavish Homes LLC is committed to delivering high-quality home remodeling services in Milwaukee. With a focus on craftsmanship and customer satisfaction, we help homeowners enhance the beauty and value of their properties.",
        "Whether you’re looking to remodel a single room or your entire house, our experienced team ensures your project is completed on time and within budget.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Lavish Homes LLC Logo",
      businessName: "Lavish Homes LLC",
      contact: {
        phone: "9453043176",
        phoneLabel: "(945) 304-3176",
        email: "Curtistownsend35@gmail.com",
        website: "https://lavishhomesllc.org/",
        address: "Milwaukee, WI, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Milwaukee, WI, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29164.474!2d-87.947!3d43.0389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88051a74abcdef%3A0x123456789!2sMilwaukee%2C%20WI!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;